<template>
  <div>
    <div>
      <div class="d-flex justify-content-between">
        <form>
          <div class="form-row align-items-center">
            <div class="col-auto my-1">
              <app-input
                type="select"
                :list="locations"
                v-model="location"
                list-value-field="label"
              />
            </div>
          </div>
        </form>
        <!-- <form>
          <div class="form-group">
            <app-input
              type="select"
              :list="[
                { id: 1, value: 'action', label: 'Response to selected' },
              ]"
              v-model="action"
              list-value-field="label"
            />
          </div>
        </form> -->
        <div class="row">
          <!-- <app-avatar
            title="avatar"
            :avatar-class="avatarClass"
            status="success"
            :shadow="true"
            :border="true"
            :img="img"
            :alt-text="altText"
          /> -->
          <button
            type="button"
            class="btn btn-secondary mr-2"
            @click="switchAccount"
          >
            Switch to another account
          </button>
        </div>
      </div>
      <div>
        <!-- <app-tab
          v-if="horizontalTabs.length"
          type="horizontal"
          :tabs="horizontalTabs"
        /> -->
        <app-overlay-loader v-if="loading" />
        <review-list :props="reviews" />
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import {
  BUSINESS_LOCATIONS,
  BUSINESS_LOCATIONS_REVIEW,
} from "../../../../Config/ApiUrl";
import ReviewList from "./components/ReviewList";

export default {
  name: "Reviews",
  mixins: [FormMixin],
  components: {
    ReviewList,
  },
  data() {
    return {
      reviews: [],
      horizontalTabs: [],
      locations: [],
      location: undefined,
      action: [1],
      loading: true,
    };
  },
  mounted() {
    this.horizontalTabs = [
      {
        name: "Review",
        icon: "eye",
        component: "ReviewList",
        props: this.respond,
      },
    ];
    this.axiosGet(BUSINESS_LOCATIONS).then((res) => {
      const tmp = res.data.locations.map((item) => ({
        id: item.name,
        value: item.name,
        label: item.title,
        ...item.latlng,
      }));
      const [zero] = tmp;
      this.location = zero?.id;
      this.locations = tmp;
    });
  },
  computed: {
    unrespond() {
      return this.reviews.filter((review) => !review.reply);
    },
    respond() {
      return this.reviews.filter((review) => review.reply);
    },
  },
  watch: {
    location(val) {
      if (val) {
        const el = this.locations.find((item) => item.id === val);
        if (!el) return;
        this.reviews = [];
        this.loading = true;
        this.axiosGet(
          `${BUSINESS_LOCATIONS_REVIEW.replace(
            "{location}",
            el.value
          )}?latitude=${el.latitude}&longitude=${el.longitude}`
        ).then((res) => {
          const tmp = res.data.result?.reviews?.map((review) => ({
            id: Date.now(),
            title: review.author_name,
            subtitle: review.text,
            avatar: review.profile_photo_url,
          }));
          this.reviews = tmp || [];
          this.loading = false;
        });
      }
    },
  },
  methods: {
    switchAccount() {
      this.axiosGet(`/business/oauth2`).then((res) => {
        console.log("res", res);
      });
    },
  },
};
</script>
